import isArray from 'lodash/isArray';
import first from 'lodash/first';
import { createSelector } from 'reselect';

import { nullIfFirstArgNegative } from '@Utils';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import { REDUCER_KEY_PROJECT_ROUTE } from './constants';
import { buildTreeFromList } from './utils/treeDataBuilder';
import { buildTableFromList } from './utils/tableDataBuilder';

export const rsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);
export const projectRoute = (state) => rsState(state).get(REDUCER_KEY_PROJECT_ROUTE);
export const isLoading = (state) => projectRoute(state).isLoading;
export const response = (state) => projectRoute(state).response;
export const routeType = (state) => {
  const resp = response(state);
  return resp && resp.routeType;
};
export const treeData = createSelector(
  [response],
  // eslint-disable-next-line no-shadow
  nullIfFirstArgNegative((response) => {
    const { routeLayout } = response;
    return routeLayout && isArray(routeLayout) ? first(buildTreeFromList(routeLayout)) : null;
  })
);
export const tableData = createSelector(
  [response],
  // eslint-disable-next-line no-shadow
  nullIfFirstArgNegative((response) => {
    const { routeLayout } = response;
    return routeLayout && isArray(routeLayout) ? buildTableFromList(routeLayout) : null;
  })
);
export const activeStep = (state) => projectRoute(state).activeStep;
export const isTransferFromReaction = (state) => projectRoute(state).isTransferFromReaction;
export const conditionsSteps = (state) => projectRoute(state).conditionsSteps;
export const conditionsPlacement = (state) => projectRoute(state).conditionsPlacement;
export const conditionsIsShown = (state) => projectRoute(state).conditionsIsShown;
export const deletedRoute = (state) => projectRoute(state).deletedRoute;
export const requestParams = (state) => projectRoute(state).requestParams;
export const selectedExamplesCount = (state) => projectRoute(state).selectedExamplesCount;
// eslint-disable-next-line no-shadow
export const isPredictedRoute = createSelector([response], (response) => {
  if (!response) {
    return false;
  }
  return response.routeType === RouteType.PREDICTED;
});
export const hasPredictedStep = createSelector(
  [response],
  // eslint-disable-next-line no-shadow
  nullIfFirstArgNegative((response) => {
    // eslint-disable-next-line no-shadow
    const { routeType, routeLayout } = response;
    return (
      routeType === RouteType.PREDICTED ||
      !!(routeType === RouteType.CUSTOMIZED && routeLayout && routeLayout.find(({ type }) => type === RouteType.PREDICTED))
    );
  })
);
